import { Route } from '@angular/router';

import {
  PageLoginComponent,
  PageOauth2LandingComponent,
  PagePwdResetComponent,
  PageResetRequestComponent,
} from '@infodata-group/inf-commons-desktop';
import { appLoaderGuard } from './guard/app-loader.guard';
import { customAuthorizationGuard } from './service/custom.authorization.guard';

export const appRoutes: Route[] = [
  { path: 'login', component: PageLoginComponent },
  {
    path: 'logout',
    loadComponent: () =>
      import('./page/page-redirect/page-redirect.component').then(
        (m) => m.PageRedirectComponent,
      ),
    data: { logout: true },
  },
  { path: 'reset-request', component: PageResetRequestComponent },
  { path: 'oauth2', component: PageOauth2LandingComponent },
  { path: 'reset-password', component: PagePwdResetComponent },
  {
    path: 'app/:appId',
    loadComponent: () =>
      import('./page/page-redirect/page-redirect.component').then(
        (m) => m.PageRedirectComponent,
      ),
    canActivate: [appLoaderGuard],
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./page/page-main/page-main.component').then(
        (m) => m.PageMainComponent,
      ),
    canActivate: [customAuthorizationGuard, appLoaderGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./page/page-home/page-home.component').then(
            (m) => m.PageHomeComponent,
          ),
      },
    ],
  },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
];
